import React, { useState, useRef, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import bg from '../assets/imgs/aboutus.webp';
import sunilSir from '../assets/imgs/director1.webp';
import nitinSir from '../assets/imgs/director2.webp';
import LeadershipTeam from './OurTeam';
import Whatsapp from './Whatsapp';

const About = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const contentRefs = useRef([]);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const getAccordionHeight = (index) => {
        if (contentRefs.current[index]) {
            return contentRefs.current[index].scrollHeight + 'px';
        }
        return '0px';
    };

    useEffect(() => {
        AOS.init({
            duration: 800, // Duration of animations
            easing: 'ease-in-out',
            once: false, // Animates only once
        });
    }, []);

    const teamMembers = [
        {
            name: 'Mr.Nitin More',
            role: 'DIRECTOR',
            qualification: 'M.Com',
            img: nitinSir,
            description: 'As a director of this company, I take immense pride in our vision to transform land ownership into an opportunity for everyone. Maharashtra offers immense potential for growth, and by focusing on prime locations, we provide our customers with the ability to invest in secure, high-value plots. We are committed to transparency, trust, and delivering quality in every plot we sell. Our goal is not just to provide land but to help people create long-term assets that contribute to their future prosperity.'
        },
        {
            name: 'Adv.Sunil Nikam',
            role: 'DIRECTOR',
            qualification: 'BE, MBA, LLB',
            img: sunilSir,
            description: 'Our journey in the real estate industry is driven by a passion for sustainable development and ethical business practices. At our company, we believe in making land investments accessible and profitable for all, whether for residential, commercial, or investment purposes. With a focus on strategic locations in Maharashtra, we ensure that every project is carefully selected to offer maximum potential for growth. As directors, our responsibility is to guide the company with integrity, providing our clients with the best opportunities to build their dreams on solid ground.'
        }
    ];

    const accordionContent = [
        {
            title: 'Who We Are',
            content: 'Samriddhi Group, established in 2010, is a trusted name in the real estate industry, offering both affordable and luxury properties across prime locations in Maharashtra. Specializing in premium land sales, we focus on providing strategic investment opportunities that promise growth potential and long-term value. Our expertise extends beyond real estate to include ventures in lifestyle interior design, and we have trained thousands of channel partners in the industry. With a strong foundation of integrity, transparency, and market expertise, we are also deeply committed to social causes, actively participating in rural development, women empowerment, and environmental initiatives like tree plantation drives. At Samriddhi Group, we are dedicated to helping individuals and families secure their future by transforming land into thriving residential or commercial spaces tailored to their needs.'
        },
        // {
        //     title: 'What We Do',
        //     content: 'We specialize in the sale of residential and commercial plots in some of the most sought-after locations across Maharashtra...'
        // },
        {
            title: 'Our Accomplishments',
            content: 'Over the years, we have successfully delivered numerous land development projects across Maharashtra...'
        }
    ];

    return (
        <>
            <div className="header">
                <img src={bg} loading="lazy" alt="About Us" />
            </div>
            <div className="aboutUs-container">
                {/* Header */}

                {/* Text Section and Accordion */}
                <div className="about-text">
                    <div className="main-text">
                        <h2 >Welcome to Samriddhi Group</h2>
                        <p>
                            At Samriddhi Group, we believe land is more than property—it's a lifestyle, an inheritance, and a personal sanctuary.  </p>
                        <p>  Our projects are born from a simple vision:</p>
                        <p><b>“Let nature enrich life, and let land enrich generations.”</b> </p>
                        <p>From mango farms in Konkan to wellness retreats near Lonavala and riverside escapes near Pune, every project balances three elements:</p>

                        <p>
                            <ul>
                                <li>Peaceful living</li>
                                <li>Smart investing</li>
                                <li>Emotional connection</li>
                            </ul>
                        </p>

                        <p>Whether you're seeking a weekend retreat, a future retirement haven, or a secure long-term investment—Samriddhi Group builds spaces where life flows naturally.</p>


                    </div>
                    <div className="accordion ">
                        {accordionContent.map((item, index) => (
                            <div key={index} className={`accordion-item ${activeIndex === index ? 'open' : ''}`}>
                                <button onClick={() => toggleAccordion(index)}>{item.title}</button>
                                <div
                                    ref={el => (contentRefs.current[index] = el)}
                                    className="accordion-content"
                                    style={{
                                        height: activeIndex === index ? getAccordionHeight(index) : '0px',
                                        transition: 'height 0.4s ease'
                                    }}
                                >
                                    <p>{item.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <h2 className='dir' >Meet Our Directors</h2>
                {/* Team Section */}
                <div className="team">
                    {teamMembers.map((member, index) => (
                        <div className="team-member" key={index}>
                            {/* Left Side Image Animation */}
                            <div data-aos="fade-right" data-aos-delay="100">
                                {/* <img src={member.img} alt={member.name} /> */}
                            </div>
                            {/* Right Side Info Animation */}
                            <div className="team-info">
                                <h3 data-aos="fade-up" data-aos-delay="200">{member.name}</h3>
                                <h4 data-aos="fade-up" data-aos-delay="300">{member.role}</h4>
                                <h4 data-aos="fade-up" data-aos-delay="400">{member.qualification}</h4>
                                <p data-aos="fade-up" data-aos-delay="500">{member.description}</p>
                            </div>
                            {/* Add social media icons here if needed */}
                        </div>
                    ))}
                </div>



                {/* <LeadershipTeam /> */}



            </div>

            <Whatsapp />

        </>
    );
};

export default About;
